var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReplyArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "7lgp8kdtga"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.188235 0 0 0 0 0.498039 0 0 0 0 0.756863 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#7lgp8kdtga)",
    transform: "translate(-501 -248) translate(429 142) translate(56 96) translate(16 8)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M7.5 3.031H6v-2.5C6 .324 5.873.14 5.68.064 5.49-.01 5.27.042 5.13.195l-5 5.5c-.173.19-.173.481 0 .672l5 5.5c.097.106.232.164.37.164.06 0 .122-.01.18-.033.193-.075.32-.26.32-.467v-2.5h1.39c2.855 0 5.619 1.022 7.785 2.88.147.127.358.156.534.074.178-.08.29-.259.29-.454 0-4.687-3.812-8.5-8.5-8.5zm-.11 5H5.5c-.276 0-.5.224-.5.5v1.707L1.176 6.031 5 1.824v1.707c0 .276.224.5.5.5h2c2.003 0 3.887.78 5.303 2.196 1.157 1.157 1.89 2.626 2.119 4.216-2.19-1.562-4.823-2.412-7.531-2.412z",
    transform: "translate(0 2)"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplyArrow);
export default __webpack_public_path__ + "static/media/reply-arrow.7e2d4894.svg";
export { ForwardRef as ReactComponent };